<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <form (submit)="onSubmit()" class="m-4" *ngIf="!isLoadingInitial()">

      <div class="row">
        <div class="col-md-8 col-xl-6">

          <div class="form-group">
            <label for="locationSelect">Location</label>
            <select class="custom-select" id="locationSelect"
                    name="locationSelect"
                    (ngModelChange)="handleLocationChange()"
                    [(ngModel)]="selectedLocationSettings">
              <option *ngFor="let locSettings of eventTypeLocationSettings" [ngValue]="locSettings">
                {{ locSettings.location_name }}
              </option>
            </select>
            <small class="form-text text-muted">
              Email settings are configured separately for each location.
            </small>
          </div>

          <div class="form-group">
            <label>Reservation Confirmation Text</label>
            <app-markdown-editor [(content)]="selectedLocationSettings.confirmation_text"
                                 (change)="unsavedChanges = true"
                                 [id]="'confirmationText'"
                                 [shortEditor]="true">
            </app-markdown-editor>
            <small class="form-text text-muted">
              This is shown on the confirmation screen after a customer creates a booking for this event, and is included in the confirmation email sent to each participant.
            </small>
            <div class="form-text text-danger">{{ errors.confirmation_text }}</div>
          </div>

          <div class="form-group">
            <label>Payment Confirmation Text</label>
            <app-markdown-editor [(content)]="selectedLocationSettings.payment_information_text"
                                 (change)="unsavedChanges = true"
                                 [id]="'paymentInformationText'"
                                 [shortEditor]="true">
            </app-markdown-editor>
            <small class="form-text text-muted">
              This is shown on the confirmation screen after a customer creates a booking for this event, and is included in the payment receipt email sent to the customer who created the booking.
            </small>
            <div class="form-text text-danger">{{ errors.payment_information_text }}</div>
          </div>

          <div class="form-group custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
                   id="sendPostEventEmailInput" name="send_post_event_email"
                   [(ngModel)]="selectedLocationSettings.send_post_event_email"
                   (ngModelChange)="unsavedChanges = true">
            <label class="custom-control-label checkbox-label"
                   for="sendPostEventEmailInput">
              Send Post-Event Email
            </label>
          </div>
          <div class="form-text text-danger">{{ errors.send_post_event_email }}</div>

          <div *ngIf="selectedLocationSettings.send_post_event_email" class="pl-3" style="border-left: 3px solid #dee2e6">

            <div class="form-group">
              <label for="postEventEmailDelayHoursInput">
                Post-Event Email Delay (Hours)
              </label>
              <input type="number" class="form-control"
                     id="postEventEmailDelayHoursInput" name="post_event_email_delay_hours"
                     min="0" step="1"
                     [(ngModel)]="selectedLocationSettings.post_event_email_delay_hours"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                The email will be sent this number of hours after the event has concluded. For multi-part events, this only applies for the last part of the event – post-event emails are not sent for earlier parts.
              </small>
              <div class="form-text text-danger">{{ errors.post_event_email_delay_hours }}</div>
            </div>

            <div class="form-group">
              <label>Post-Event Email Text</label>
              <app-markdown-editor [(content)]="selectedLocationSettings.post_event_email_text"
                                   (change)="unsavedChanges = true"
                                   [id]="'postEventEmailText'"
                                   [shortEditor]="true">
              </app-markdown-editor>
              <small class="form-text text-muted">
                This is included in the post-event email beneath the event name and date.
              </small>
              <div class="form-text text-danger">{{ errors.post_event_email_text }}</div>
            </div>

            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                       id="postEventEmailAttendeesOnlyInput" name="post_event_email_attendees_only"
                       [(ngModel)]="selectedLocationSettings.post_event_email_attendees_only"
                       (ngModelChange)="unsavedChanges = true">
                <label class="custom-control-label checkbox-label"
                       for="postEventEmailAttendeesOnlyInput">
                  Only Send to Attendees
                </label>
              </div>
              <small class="form-text text-muted">
                When enabled, the post-event email is only sent to participants who checked in to the event. For a multi-part event, checking in to any part counts. Anyone who booked but never checked in will not receive it.
              </small>
              <div class="form-text text-danger">{{ errors.post_event_email_attendees_only }}</div>
            </div>

          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     id="sendReminderEmailInput" name="send_reminder_email"
                     [(ngModel)]="selectedLocationSettings.send_reminder_email"
                     (ngModelChange)="unsavedChanges = true">
              <label class="custom-control-label checkbox-label"
                     for="sendReminderEmailInput">
                Send Event Reminder Email
              </label>
            </div>
            <small class="form-text text-muted">
              Event reminder emails are sent to all participants.
            </small>
            <div class="form-text text-danger">{{ errors.send_reminder_email }}</div>
          </div>

          <div *ngIf="selectedLocationSettings.send_reminder_email" class="pl-3" style="border-left: 3px solid #dee2e6">

            <div class="form-group">
              <label for="reminderEmailLeadHoursInput">
                Event Reminder Email Lead (Hours)
              </label>
              <input type="number" class="form-control"
                     id="reminderEmailLeadHoursInput" name="reminder_email_lead_hours"
                     min="0" step="1"
                     [(ngModel)]="selectedLocationSettings.reminder_email_lead_hours"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                The email will be sent this number of hours before the event begins. For multi-part events, this only applies for the first part of the event – reminder emails are not sent for later parts.
              </small>
              <div class="form-text text-danger">{{ errors.reminder_email_lead_hours }}</div>
            </div>

            <div class="form-group">
              <label>Event Reminder Email Text</label>
              <app-markdown-editor [(content)]="selectedLocationSettings.reminder_email_text"
                                   (change)="unsavedChanges = true"
                                   [id]="'reminderEmailText'"
                                   [shortEditor]="true">
              </app-markdown-editor>
              <small class="form-text text-muted">
                This is included in the event reminder email beneath the reservation details.
              </small>
              <div class="form-text text-danger">{{ errors.reminder_email_text }}</div>
            </div>

          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     id="sendWaiverEmailInput" name="send_waiver_email"
                     [(ngModel)]="selectedLocationSettings.send_waiver_email"
                     (ngModelChange)="unsavedChanges = true">
              <label class="custom-control-label checkbox-label"
                     for="sendWaiverEmailInput">
                Send Waiver Reminder Email
              </label>
            </div>
            <small class="form-text text-muted">
              Waiver reminder emails are sent when a participant does not have an active waiver on file at the event's location. The email is sent to the participant, the booking customer, and any other customers linked as parents/guardians of the participant.
            </small>
            <div class="form-text text-danger">{{ errors.send_waiver_email }}</div>
          </div>

          <div *ngIf="selectedLocationSettings.send_waiver_email" class="pl-3" style="border-left: 3px solid #dee2e6">

            <div class="form-group">
              <label for="waiverEmailLeadHoursInput">
                Waiver Reminder Email Lead (Hours)
              </label>
              <input type="number" class="form-control"
                     id="waiverEmailLeadHoursInput" name="waiver_email_lead_hours"
                     min="0" step="1"
                     [(ngModel)]="selectedLocationSettings.waiver_email_lead_hours"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                The email will be sent this number of hours before the event begins. For multi-part events, this only applies for the first part of the event – reminder emails are not sent for later parts.
              </small>
              <div class="form-text text-danger">{{ errors.waiver_email_lead_hours }}</div>
            </div>

            <div class="form-group">
              <label>Waiver Reminder Email Text</label>
              <app-markdown-editor [(content)]="selectedLocationSettings.waiver_email_text"
                                   (change)="unsavedChanges = true"
                                   [id]="'waiverEmailText'"
                                   [shortEditor]="true">
              </app-markdown-editor>
              <small class="form-text text-muted">
                This is included in the waiver reminder email above the waiver link.
              </small>
              <div class="form-text text-danger">{{ errors.waiver_email_text }}</div>
            </div>

            <div class="form-group">
              <label for="waiver_email_document_template_id">
                Waiver Reminder Email Document Template
              </label>
              <select class="custom-select"
                      id="waiver_email_document_template_id"
                      name="waiver_email_document_template_id"
                      [(ngModel)]="selectedLocationSettings.waiver_email_document_template_id"
                      (ngModelChange)="unsavedChanges = true">
                <option [ngValue]="null"
                        disabled class="disabled">---</option>
                <option *ngFor="let dt of waiverEmailTemplateOptions" [ngValue]="dt.id">
                  {{ dt.name }}{{ dt.isRetired ? ' (Retired)' : '' }}
                </option>
              </select>
            </div>

          </div>

          <div class="form-group custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input"
                   id="bookingStaffNotificationSelectedInput" name="bookingStaffNotificationSelected"
                   [(ngModel)]="bookingStaffNotificationSelected[selectedLocationSettings.id]"
                   (ngModelChange)="unsavedChanges = true">
            <label class="custom-control-label checkbox-label"
                   for="bookingStaffNotificationSelectedInput">
              Send Booking Notification Email to Selected Staff
            </label>
          </div>

          <div *ngIf="bookingStaffNotificationSelected[selectedLocationSettings.id]" class="pl-3" style="border-left: 3px solid #dee2e6">

            <div class="form-group">
              <label for="staffNotificationEmailAddressesInput">
                Notification Email Addresses
              </label>
              <input type="text" class="form-control"
                     id="staffNotificationEmailAddressesInput" name="staff_notification_email_addresses"
                     [(ngModel)]="selectedLocationSettings.staff_notification_email_addresses"
                     (ngModelChange)="unsavedChanges = true">
              <small class="form-text text-muted">
                Provide one or more email addresses, separated by commas. These email addresses will receive a notification whenever a booking is made for this event type.
              </small>
              <div class="form-text text-danger">{{ errors.staff_notification_email_addresses }}</div>
            </div>

          </div>

        </div>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
        {{ errors.non_field_errors }}
      </div>
      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
      <div class="alert alert-success" role="alert" *ngIf="successMessage">
        {{ successMessage }}
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventType">
        Loading...
      </div>

      <div class="float-right">
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="isLoadingSubmit()" [class.disabled]="isLoadingSubmit()"
                (click)="submitType=SUBMIT_TYPE_STAY_HERE">
          Save
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="isLoadingSubmit()" [class.disabled]="isLoadingSubmit()"
                (click)="submitType=SUBMIT_TYPE_CONTINUE">
          Save and Continue
        </button>
      </div>
      <button [routerLink]="['/events/setup/event-types']"
              [queryParams]="{status: eventType?.status}"
              class="btn btn-secondary"
              [disabled]="isLoadingSubmit()" [class.disabled]="isLoadingSubmit()">
        Back
      </button>

    </form>

  </div>

</div>
